export default "__VITE_ASSET__DyWesLsk__"